export enum InductionTranslationKeyEnum {
  PageTitle = "header.induction",
  DocumentTitle = "induction.pageTitle",
}
